function forceDownload(url, fileName) {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = function() {
    var urlCreator = window.URL || window.webkitURL;
    var imageUrl = urlCreator.createObjectURL(this.response);
    var tag = document.createElement('a');
    tag.href = imageUrl;
    tag.download = fileName;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  }
  xhr.send();
}

function showBootstrapAlert(selector, message) {
  var alert = ($.type(selector) === "string" ? $(selector) : selector);
  if (alert.show) {
    $('.alert-content', alert).html(message);
    alert.show();
  } else {
    console.error('[' + selector + '] is not a jquery dom object');
  }
}

function hideBootstrapAlert(selector) {
  var alert = ($.type(selector) === "string" ? $(selector) : selector);
  if (alert.hide) {
    alert.hide();
  } else {
    console.error('[' + selector + '] is not a jquery dom object');
  }
}
function customizeFilterTree2(filterValue,filterID) {

console.log('customizing...')
  
$('.gf-block-content.globo-selected-items').find('.selected-item.gf-option-label').last().hide();

  var getOptionBlock = function(title) {
    return $('.gf-block-title :contains(' + title + ')').closest('.gf-option-block');
  }

  var familyColorwayFilter = getOptionBlock('Product Type');
  console.log(familyColorwayFilter)
 familyColorwayFilter.hide();
  var currentSelectedProduct = familyColorwayFilter.find('.checked').attr('title');
  console.log('selected');
  console.log(currentSelectedProduct);


 if (currentSelectedProduct == undefined) {
  console.log('not selected')
  window.location = '/collections/all-products-filter?gf_121547=Product+Fabric+Family'
  //$(familyColorwayFilter).find('[title="Product Fabric Family"]').click();
 } else {
    if (currentSelectedProduct != filterValue)  {
       toggleRadioFilter(filterID,filterValue)
    } }
  var collectionsFilter = getOptionBlock('Collections');

   
}

$(document).ready(function() {
  // for social buttons
  var social_modal = $('#social_modal');
  if (social_modal) {
    $('.dialog').webuiPopover({
      content: social_modal.html(),
      placement: (screen.width < 767 ? 'auto' : 'bottom')
    });
  }
  
  $("#print_luum").click(function() { window.print(); });

  // for bootstrap dismissible alerts  
  $('body').on('click', '.alert-dismissible .close', function() {
    $(this).parents('.alert-dismissible').hide();
  });
  
  // for sample card
  $('.downloadable').click(function() {
    forceDownload($(this).attr("filename"), $(this).attr("title"));
  });
  
  /** country/provice drop down pairs **/
  var statesListByCountry = {
    Canada: [ "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Yukon" ],
    US:     [ 'Alabama','Alaska','American Samoa','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','District of Columbia','Federated States of Micronesia','Florida','Georgia','Guam','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Marshall Islands','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Northern Mariana Islands','Ohio','Oklahoma','Oregon','Palau','Pennsylvania','Puerto Rico','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming', 'Virgin Islands', 'Armed Forces Americas', 'Armed Forces Europe', 'Armed Forces Pacific' ]
  };

  $('select.country_drop_down').change(function(ev) {
    var target = $(ev.target);
    var value = target.val();
    // assume consistent identifiers on country and related state fields
    var state_identifier = target.attr('id').replace('country', 'state');
    var state_select = $('#' + state_identifier, target.parents('form'));
    if (!value || value.length == 0) {
      state_select.html('<option value="" selected disabled hidden></option>');
    } else {
      var stateOptions = '<option value="" selected="" disabled="" hidden="">Province/State</option>'
      	+ statesListByCountry[value].map(function(state) { return "<option value=" + state + ">" + state + "</option>" });
      state_select.html(stateOptions);
    }
  }).each(function(index, elem) {
    var country_select = $(elem);
    var defaultCountry = country_select.attr('data-default-country');
    $('option[value="' + defaultCountry + '"]', country_select).prop('selected', true);
    country_select.change();
  });

  $('select.state_drop_down').each(function(index, elem) {
    var provice_select = $(elem);
    var defaultProvince = provice_select.attr('data-default-province');
    $('option[value="' + defaultProvince + '"]', provice_select).prop('selected', true);
    provice_select.change();
  });

  /** tab containers **/
  $('.tab-container .nav li').click(function(ev) {
    var target = $(ev.target);
    if (!target.hasClass('tab')) {
      // click target was a child of the tag with the listener, need to switch to that parent
      target = $(target.parents(".tab")[0]);
    }
    // switch tabs if target is not already active
    if (!target.hasClass('active')) {
      $('.nav li.active').removeClass('active');
      target.addClass('active');

      var tab_name = target.attr('data-target-tab');
      $('.tab_content').hide();
      $('#' + tab_name).show();
    }
  });
  $('.tab-container').each(function(index, tab_container) {
    // activate first tab in container since click handlers have now been assigned
    var container = $(tab_container);
    $('.nav li:first', container).click();
    container.show();
  });

  /** .inputfile **/
  var inputs = document.querySelectorAll('.inputfile');
  Array.prototype.forEach.call(inputs, function(input) {
    var label = input.nextElementSibling,
        labelVal = label.innerHTML;

    input.addEventListener('change', function(e) {
      var fileName = '';
      if (this.files && this.files.length > 1 ) {
        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
      } else {
        fileName = e.target.value.split("\\").pop();
      }

      if (fileName) {
        label.querySelector('span').innerHTML = fileName;
      } else {
        label.innerHTML = labelVal;
      }
    });
  });

  /** for snippet/product-description-collapsible.liquid **/
  (function(sectionAllSelector, menuItemSelector, menuItemClassName, menuItemActiveClassName, hasFancyboxClassName) {
    $(menuItemSelector).click(function(ev) {
      var clicked = $(ev.target);
      if (!clicked.hasClass(menuItemClassName)) {
        // click target was a child of the tag with the listener, need to switch to that parent
        clicked = $(clicked.parents("." + menuItemClassName)[0]);
      }
      // toggle visibility if clicked item isn't already visible
      if (!clicked.hasClass(menuItemActiveClassName)) {
        var showSection = $('#' + clicked.attr('data-target'));
        $(menuItemSelector).removeClass(menuItemActiveClassName);
        clicked.addClass(menuItemActiveClassName);
        $(sectionAllSelector).hide();
        showSection.show();

        // trigger fancybox if necessary
        if (clicked.hasClass(hasFancyboxClassName)) {
          $('.fancybox-target', showSection).click();
        }
      }
    });

    // initialize first section as selected
    $(menuItemSelector + ':first').click();
  })(
    '#description-collapsible-container .description-collapsible-section',
    '#description-collapsible-menu .description-collapsible-menu-item',
    'description-collapsible-menu-item',
    'description-collapsible-menu-item-active',
    'has-fancybox'
  );

  /** add click listeners for fancybox modals **/
  $('.fancybox-target').click(function(ev) {
    var target = $(ev.target);
    if (!target.hasClass('fancybox-target')) {
      // click target was a child of the tag with the listener, need to switch to that parent
      target = $(target.parents('.fancybox-target')[0]);
    }
    var modalSelector = "#" + target.attr("data-fancybox-modal");
    $.fancybox($(modalSelector));
  });

  $("#tag_image_div").mouseover(function() {
    $(".hover_span").css("display", "inline");
  });

  $(".drop_menu").click(function() {
    $(this).parent(".navigation_item").toggleClass("open_dropmenu");
    $(this).parent(".navigation_item").find(".dropdown_menu").slideToggle("swing");
  });

  $(".menu_icon").click(function(event) {
    event.preventDefault();
    $(".luum_menu").removeClass("cart_menu_open");
    $("body").toggleClass("open_menu");

    $("#nav_menu_view").css("display", "inline");
    $("#cart_menu_view").css("display", "none");
  });

  $(".close_icon").click(function() {
    $(".luum_menu").removeClass("cart_menu_open");
    $("body").removeClass("open_menu");
  });

  var my_ac = $(".navigation_item").find(".dropdown_menu");
  if (my_ac.length == 1) {
    $(".dropdown_menu").parent().addClass("dropdown_in");
  }

  /** for snippet/product-form.liquid **/
  var product_form = $('.product_form');
  if (product_form.length) {
    // add item to cart, adding half item *synchronously* first if needed
    $("#add-to-cart").on("click", function() {
      var line_item_unique_id = Date.now();
      var requests = [
        {
          id: $('[name=id]', product_form).val(),
          quantity: parseInt($('[name=quantity]', product_form).val(), 10) || 0,
          properties: {
            'line_item_unique_id': line_item_unique_id,
          }
        }
      ];

      var half_product_id = $("#half-quantity:checked").val();
      if (half_product_id) {
        requests.unshift({
          id: half_product_id,
          quantity: 1,
          properties: {
            'line_item_unique_id': line_item_unique_id,
          }
        });
      }
      
      // have to replace the true with enhancements
      var enhancement_price = parseFloat($('.enhancement_price').val());
        var enhancement_variant_id = $('#enhancement-id').attr('data')
      if (enhancement_price) {
       	requests.unshift({
          id: enhancement_variant_id,
          quantity: 1,
          properties: {
    		'enhancementPrice': enhancement_price,
            'enhancementSKU' : $('#variant-id :selected').attr('data-sku'),
            'line_item_unique_id': line_item_unique_id,
  		  }
        });
      }

      var self = $(this);
      var success_modal = $("#" + self.attr("data-fancybox-modal"));
      var error_modal = $("#" + self.attr('data-fancybox-error-modal'));

      var next = function() {
        if (requests.length > 0) {
          var data = requests.shift();
          $.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: data,
            success: next,
            error: function(xhr, textStatus, errorThrown) {
              var response = $.parseJSON(xhr.responseText);
              var msg = "Unexpected error. Please try again.";
              if (response.description.startsWith('You can only add')) {
                msg = "Sorry, we don't have enough.";
              }
              $('.message', error_modal).text(msg);
              $.fancybox(error_modal);
            },
            dataType: 'json',
          });
        } else {
          $.ajax({
            type: 'GET',
            url: '/cart.js',
            success: function(data) {
              if (Array.isArray(data.items)) {
                $('#cart_count_value').text(data.items.length);
              }
              $.fancybox(success_modal);
            },
            error: function(xhr, textStatus, errorThrown) {
              console.log(xhr, textStatus, errorThrown);
            },
            dataType: 'json',
          });
        }
      };
      next();
    });
    $('.continue-shopping').click(function() {
      window.location = window.location.href;
    });

    var set_half_product_checkbox = function(checkbox_value) {
      // convert param to boolean
      var bool_value = !!checkbox_value;
      // update the value of the checkbox, if it has no value, then disable and uncheck, otherwise enable and leave state as is
      // then update parent row style
      var half_product_checkbox = $("#half-quantity");
      half_product_checkbox
      .val(checkbox_value)
      .prop("disabled", !bool_value)
      .prop("checked", bool_value && half_product_checkbox.prop("checked"))
      .parents(".row").toggleClass("disabled", !bool_value);
    }

    var shop_currency = product_form.attr("data-currency");
    $("#variant-id").change(function(ev) {
      var selected = $("#variant-id option:selected");

      // determine ID for associated half yard -- if required
      var half_product_checkbox = $("#half-quantity");
      var half_product_id = selected.attr("data-half-product-id");
      if (half_product_id) {
        set_half_product_checkbox(half_product_id);
      } else {
        var half_product_sku = selected.attr("data-half-product-sku");
        if (half_product_sku) {
          $.ajax({
            url: "/products/" + half_product_sku + ".js",
            dataType: "json",
            success: function(result) {
              var half_product = result;
              if (half_product) {
                var half_product_id = "";
                for (var i = 0; i< half_product.variants.length; i++) {
                  var variant = half_product.variants[i];
                  // console.log(variant.sku);
                  // console.log(half_product_sku);
                  if (variant.sku == half_product_sku) {
                    half_product_id = variant.id;
                    break;
                  }
                }
                
                selected.attr("data-half-product-id", half_product_id);
                set_half_product_checkbox(half_product_id);
              } else {
                set_half_product_checkbox('');
              }
            }
          });
        } else {
          set_half_product_checkbox("");
        }
      }
      
      // check variant availability
      var available = selected.attr('data-available') == 'true';
      product_form.toggleClass('variant-available', available).toggleClass('variant-unavailable', !available);

      // update price on page
      var price = $($('#variant-id')[0]).find(':contains(Yardage / None)').attr('data-price');
      $('.price-value').text(Shopify.formatMoney(price));

      // update price label
      var uom = selected.attr('data-unit-of-measure');
      $('.price-label').text('Price ' + $($('#variant-id')[0]).find(':contains(Yardage / None)').attr('data-unit-of-measure'));
      // disable enhancements if new variant can't be enhanced
      var variant_cannot_enhance = !selected.attr("data-can-enhance");
      $('#add-enhancements').prop('disabled', variant_cannot_enhance);
      $('#add-enhancements').parents('.row').toggleClass('disabled', variant_cannot_enhance);

      // mark as telephone only if variant specifies
      var telephone_only = !!selected.attr("data-telephone-only");
      product_form.toggleClass("telephone-only", telephone_only);
    });
    $("#variant-id").change();

    $(".variant-type-select").change(function(ev) {
      // switch to first item of new variant type
      var target = $(ev.target);
      var variant_type = target.val();
      var variant_select = $("#variant-id");
      var variant_option = $("option[data-variant-type='" + variant_type + "']:first", variant_select);
      
      $('#half-quantity-section, #enhancements-section').toggleClass('hidden', target.hasClass('memo'));

      var enhancement_select = $('#add-enhancements-modal .enhancement-options');
      enhancement_select.val(variant_option.val()).change();
      calculateEnhancementCharge();
      
      variant_select.val(variant_option.attr("value")).change();
    }).filter(':checked').change();

    /** for snippet/product-form-enhancements.liquid **/
    var add_enhancement_modal_id = 'add-enhancements-modal';
    $('[data-fancybox-modal="' + add_enhancement_modal_id + '"]').click(function(ev) {
      var modalSelector = "#" + add_enhancement_modal_id;
      $.fancybox($(modalSelector), {
        beforeShow: function() {
          // set drop downs to options from selected variant
          var selected_variant = $("#variant-id option:selected");
          $('#add-enhancements-modal .enhancement-options').val(selected_variant.val());
        }
      });
    });
    $('#add-enhancements-modal-cancel').click(function() {
      $.fancybox.close();
    });
    
    /*
    $('#add-enhancements-modal-apply').click(function() {
      // create a string representing the selected options (including yardage vs memo)
      var enhancement_fields = $("#add-enhancements-modal .enhancement-options");
      var selected_variant_title = $('input[name="variant_type"]:checked').val();
      enhancement_fields.each(function(index, elem) {
        selected_variant_title += " / " + $(elem).val();
      });

      // use that string to find option in variant select -- if configuration exists
      var selected_variant_option = $("#variant-id option").filter(function() {
        return $(this).text() == selected_variant_title;
      });
      if (selected_variant_option) {
        selected_variant_option.prop("selected", true).change();
        $.fancybox.close();
      } else {
        alert("configured variant doesn't exist");
      }
    });
    */
    
    function extractEnhancementCharges() {
      var selected = $('#enhancement_options').find(':selected');
      return {
        minimumCharge: selected.attr('data-min-charge'),
        minimumYard: selected.attr('data-min-yard'),
        costPerYard: selected.attr('data-cost-per-yard')
      };
    }
    
    $('#enhancement_options').change(function () {
      var attrs = extractEnhancementCharges();
      $('#min-yard').text(attrs['minimumYard']);
      $('#cost-per-yard').text('$' + attrs['costPerYard']);
      $('#min-charge').text('$' + attrs['minimumCharge']);
    });
    
    function calculateEnhancementCharge() {
      var attrs = extractEnhancementCharges();
      var minimumCharge = parseFloat(attrs['minimumCharge']);
      var minimumYard = parseFloat(attrs['minimumYard']);
      var costPerYard = parseFloat(attrs['costPerYard']);
      
      var actualQuantity = parseFloat($('#quantity').val());
      var totalEnhancementPrice = actualQuantity * costPerYard;
      
      $('.enhancement_price').val(Math.max(totalEnhancementPrice, minimumCharge).toFixed(2))
                             .toggleClass('hidden', costPerYard == 0.0);
      $('#add-enhancements').toggleClass('hidden', costPerYard != 0.0);
      
      //console.log(actualQuantity);
      //console.log(minimumYard);
      if (actualQuantity < minimumYard) {
        $('#quantity').val(minimumYard);
      }
    }
    
    $('#quantity').change(function() {
      if ($('.enhancement_price').val() != "") {
        calculateEnhancementCharge();
      }
    });
    
    $('#add-enhancements-modal-apply').click(function() {
      calculateEnhancementCharge();
      $('#variant-id').val($('#enhancement_options').val()).change();
      $.fancybox.close();
      /*
      // Below assumes the concatenation of multiple options
      // create a string representing the selected options (including yardage vs memo)
      var enhancement_fields = $("#add-enhancements-modal .enhancement-options");
      var selected_variant_title = $('input[name="variant_type"]:checked').val();
      enhancement_fields.each(function(index, elem) {
        selected_variant_title += " / " + $(elem).val();
      });
      
      //console.log('Selected Variant: ' + selected_variant_title);
      // use that string to find option in variant select -- if configuration exists
      var selected_variant_option = $("#variant-id option").filter(function() {
        return $(this).text() == selected_variant_title;
      });
      if (selected_variant_option) {
        selected_variant_option.prop("selected", true).change();
        $.fancybox.close();
      } else {
        alert("configured variant doesn't exist");
      }*/
    });
  }

  /** for snippet/account-reservations.liquid **/
  var customer_reservations = $('#customer_reservations');
  if (customer_reservations.length) {
    var customer_id = customer_reservations.attr('data-customer-id');
    var table = $('table', customer_reservations);

    function getReservations(sort_by, order_by) {
      var num_cols = $('thead tr:first th', table).length;
      var tbody = $('tbody', table);
      var loading_row = $('tr.loading', tbody);

      $('tr', tbody).not('.loading').remove();
      loading_row.show();

      return teknion.internal_luumca_reservations.index(customer_id, sort_by, order_by)
      .done(function(data) {
        if (data.message) {
          tbody.append('<tr class="error"><td colspan="' + num_cols + '">' + data.message + '</td></tr>');
        } else {
          var count = 0;
          Object.keys(data).forEach(function (key) {
            var reservation = data[key];
            var checkoutLink = "";
            if (data[key]['status'] == 'Allocated'){
              checkoutLink = '<a href="#">Checkout</a><div style="display:none" id="'+key+'" class=productIds>'+data[key]['product_ids']+'</div>';
            }
            
            tbody.append('<tr>'
                         + '<td class="reservation_number">'
                         + '<a href="#" class="view_details" data-reservation-id="' + reservation['reservation_id'] + '">' + key + ' </a>'
                         + '<div class="hidden"><div id="reservation_' + reservation['reservation_id'] + '_details" data-loaded="">'
                         + '<div class="reservation_details"></div>'
                         + (reservation['status'] == 'Allocated'
                            ? '<div class="reservation_checkout"><div class="row"><div class="col-sm-6 col-sm-offset-3"><input type="button" value="Checkout" class="button-link convert-reservation-to-checkout" data-product-details=\'' + JSON.stringify(reservation['product_details']) + '\' /></div></div></div>'
                            : '')
                         + '</div></div>'
                         + '</td>'
                         + '<td>' + reservation['expiry_date'] + '</td>'
                         + '<td>' + reservation['status'] + '</td>'
                         + '<td class=convertToCheckout>' + checkoutLink + '</td>'
                         + '</tr>');
            count++;
            $('#'+key).data(data[key]['product_details']);
          });
          triggerConvertToCheckout();
          if (count == 0) {
            tbody.append('<tr><td colspan="' + num_cols + '">No reservations found</td></tr>');
          }
        }
      })
      .fail(function(data) {
        var message = "An unexpected error has occured. Please try again later.";
        tbody.append('<tr><td colspan="' + num_cols + '">' + message + '</td></tr>');
      })
      .always(function() {
        loading_row.hide();
      });
    }
    
    
    //Convert Reservation to Checkout
    function triggerConvertToCheckout(){
      $('.convertToCheckout').on('click', function(){
        var reservationId = $(this).siblings('.reservation_number').text()
        Shopify.queue = [];
        var quantity = 0;
        var productIds = $(this).children('.productIds').data()
        $.each(productIds, function(key, value){
          Shopify.queue.push({
            variantId: key,
            quantity: value
          })
        });

        Shopify.moveAlong = function() {
          if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            var data = {'id': request.variantId, 'quantity': request.quantity, 'reservation_id': 'test', 'attributes[reservation_id]': reservationId};
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: data,
              success: function(res){
                Shopify.moveAlong();
                quantity += 1;
              },
              error: function(){
                if (Shopify.queue.length){
                  Shopify.moveAlong()
                } else {
                  window.location.href = "/cart";
                }
              }
            });
          }
          else {
            window.location.href = "/cart";
          }
        };
        Shopify.moveAlong();
      })
    }


    table
    .on('click', '.sortorder', function() {
      var sortBy = $(this).attr('data-sortby');

      var orderBy = ($(this).data()['orderby'] == 'desc' ? 'asc' : 'desc');
      $(this).data()['orderby'] = 'orderBy';

      getReservations(sortBy, orderBy);
    })
    .on('click', 'a.view_details', function(ev) {
      var target = $(ev.target);

      var is_fetching = !!target.attr('data-fetching');
      if (!is_fetching) {
        target.attr('data-fetching', true);

        var request_id = target.attr('data-reservation-id');
        var container = $('#reservation_' + request_id + '_details');
        var details = $('.reservation_details', container)

        var is_loaded = !!target.attr('data-loaded');
        if (is_loaded) {
          $.fancybox(container);
        } else {
          teknion.internal_luumca_reservations.get(customer_id, request_id)
          .done(function(data) {
            var content = data
            .replace(/^[\s\S]*?<body>([\s\S]*?)<\/body>[\s\S]*?$/,"$1")
            .replace(/colmd3/g, 'col-xs-12 col-sm-4')
            .replace(/h3/g, 'h3 class="col-xs-12"');
            details.append(content);
            target.attr('data-loaded', true);
          })
          .fail(function(data) {
            console.log('get#fail', data);
            details.append(data);
          })
          .always(function(data) {
            $.fancybox(container);
            target.attr('data-fetching', '');
          });
        }
      }
      return false;
    });

    $("body").on("click", ".convert-reservation-to-checkout", function() {
      var button = $(this);
      var product_details = JSON.parse(button.attr('data-product-details'));
      var items = [];
      $.each(product_details, function(key, value) {
        items.push({ id: key, quantity: value });
      });
      var next = function() {
        if (items.length > 0) {
          $.post('/cart/add.js', items.shift(), next, 'json');
        } else {
          window.location.href = "/cart";
        }
      };
      next();
    });

    // first load
    var sort_by = 'request_number';
    var order_by = 'desc';
    getReservations(sort_by, order_by);
  }

  //---------------------------Checkout Validation-----------------------

  /*
    Validation to check PO Numbers and Customer Numbers.
    Must comply to regex. No special characters or no printable characters.

    Also Trims results.
  */
  $(".validation_field").blur(function() {
    var po_reg = new RegExp('^[a-zA-Z0-9 _.-]*$');
    var po_to_test = $(this).val();
    po_to_test = po_to_test.trim();

    if (po_reg.test(po_to_test)) {
      //console.log("Regex validated to True.");
      $(this).val(po_to_test);
      $("#" + this.id + "_msg").html("");
      //$("#submit_link").removeAttr("disabled");
    } else {
      //console.log("Regex validated to False.");
      //console.log(this.id + "_msg");
      $("#" + this.id + "_msg").html("Invalid input " + String(po_to_test));
      //$("#submit_link").attr("disabled", "disabled");
    }
  });

  /*
    Check validation before going to checkout.
  */
  $("#checkout").click(function(e) {
    var bool_val= false;
    var error_msg = "";

    var empty_fields_arr = [];
    //Check if a field with this class has a blank value.
    $(".validation_field").filter(function () {
      empty_fields_arr.push($.trim($(this).val()).length == 0);
    }).length == 0;

    //If at least one field is filled in than the other field(s) must also be present.
    if (empty_fields_arr.indexOf(false) > -1 && empty_fields_arr.indexOf(true) > -1) {
      bool_val = true;
      $("#customer_po_number_field_msg").append("<br/>Both input fields are required.");
    }

    //Check if an error is present on the screen.
    $(".custom_error_msg").filter(function () {
      if($.trim($(this).html()).length > 0) {
        bool_val = true;
      }
    }).length == 0;

    if (bool_val) {
      console.log("Failed to checkout. Invalid messages present.");
      e.preventDefault();
    }
  });

  //--------------------------------------------------------------------
});

$(function() {
  $('a[href*=#]:not([href=#])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({ scrollTop: target.offset().top-50 }, 1000);
        return false;
      }
    }
  });
});

function toggle_to_tag() {
  var url = $("#toggle_tag_url").val();
  $('#feature_image a').attr("href", url);
  $('#feature_image img').attr("src", url);
}

function toggle_to_feature() {
  var url = $("#toggle_feat_url").val();
  $('#feature_image a').attr("href", url);
  $('#feature_image img').attr("src", url);
}


/*********START GEO MODAL FUNCTIONS*****************/
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function check_response() {
  if (getCookie("redirect_to_US")=="true") {
    window.location.href="https://store.luumtextiles.com" + window.location.pathname;
  } else if (getCookie("redirect_to_CA")=="true") {
    window.location.href="https://store.luumtextiles.ca" + window.location.pathname;
  }
}

function closeModal(country) {
  if ($('.checkbox_accept_cookie').is(":checked")) {
    setCookie("redirect_close", "true");
  }
  $.fancybox.close(true);
}

function continue_modal(redirect_url, country) {
  var check_box_name = ("#" + country + "_checkbox_accept_cookie");
  if ($(check_box_name).is(':checked')) {
    setCookie(("redirect_to_"+country), "true");
  }
  window.location.href=redirect_url + window.location.pathname;
}

/*********END GEO MODAL FUNCTIONS*****************/

function checkMainPage(){
  
if (window.location.href.includes('search') ) {
  return false;
}
  else {
    return true;
  }
}

